import React from "react";
import StoreItemDetailsView from "../component/StoreItemDetailsView";

const StoreItemDetailContainer = ({ pageId }) => (<StoreItemDetailsView pageId={ pageId } />)

export default StoreItemDetailContainer;
